import { render, staticRenderFns } from "./CompanyUpdateDialogAdditionalInfos.vue?vue&type=template&id=d264fcbc&scoped=true&"
import script from "./CompanyUpdateDialogAdditionalInfos.vue?vue&type=script&lang=ts&"
export * from "./CompanyUpdateDialogAdditionalInfos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d264fcbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VForm,VRow})
